export function truncate(value: string, limit = 30, append = '...'): string {
  if (!value || !limit) {
    return '';
  }

  value = value + '';
  if (value.length <= limit) {
    return value;
  }

  const truncated = value.substring(0, limit);

  return `${value.substring(0, Math.min(truncated.length, truncated.lastIndexOf(' ')))}${append}`;
}
